import * as S from "./InquiryFaqItem.style";
import { Faq } from "@/common/types/inquiry";
import DOMPurify from "dompurify";
import { useState } from "react";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";

interface InquiryFaqItemProps {
  faq: Faq;
}

export const InquiryFaqItem = ({ faq }: InquiryFaqItemProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const safeContent = DOMPurify.sanitize(faq.content);

  const handleItemOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <S.InquiryFaqItem>
      <S.ItemTit $active={isOpen} onClick={handleItemOpen}>
        <div>
          <span>Q</span> {faq.title}
        </div>
        <IconArrow width={20} height={20} />
      </S.ItemTit>

      <S.ItemAnswer $active={isOpen}>
        <span>A</span>
        <div dangerouslySetInnerHTML={{ __html: safeContent }} />
      </S.ItemAnswer>
    </S.InquiryFaqItem>
  );
};
